import styled, { css } from 'styled-components';

export const CustomSelectContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
`;

export const SelectBox = styled.div`
  ${({ src }) => css`
    display: flex;
    align-items: center;
    height: 2.375rem;
    box-sizing: border-box;
    padding: 0 0.75rem;
    border: 1px solid #c4c4c4;
    border-radius: 0.625rem;
    cursor: pointer;
    background: #ffffff;
    position: relative;
    transition: all 0.2s ease;

    &:focus-within,
    &:hover {
      border-color: var(--second-color);
      box-shadow: 0 0 0 2px rgba(0, 137, 58, 0.15);
    }

    svg {
      color: ${src ? 'var(--white-color)' : 'var(--second-color)'};
      width: 1.125rem;
      height: 1.125rem;
      flex-shrink: 0;
      margin-right: 0.5rem;
    }
  `}
`;

export const InputField = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-family: 'Inter', sans-serif;
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${({ src }) => (src ? 'var(--white-color)' : 'var(--first-color)')};
  background-color: transparent;

  &::placeholder {
    color: #8f9b94;
    font-size: 0.875rem;
  }
`;

export const Arrow = styled.span`
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.375rem;
  color: ${({ src }) => (src ? 'var(--white-color)' : '#8f9b94')};
  transition: transform 0.2s ease;
`;

export const OptionsList = styled.ul`
  ${({ src }) => css`
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.75rem;
    border: 1px solid rgba(0, 137, 58, 0.15);
    list-style: none;
    padding: 0.375rem;
    max-height: 280px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    z-index: 1000;
  `}
`;

export const OptionItem = styled.li`
  padding: 0.65rem 0.875rem;
  cursor: pointer;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--first-color);
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: #e9f2eb;
    color: var(--second-color);
    font-weight: 600;
  }
`;

export const NoOption = styled.li`
  padding: 0.875rem 1rem;
  color: #8f9b94;
  font-size: 0.875rem;
  text-align: center;
`;
